import Service from 'core/service'

export class DivisionService extends Service {
  getAllDivision(company: string, region: string, name: string): Promise<DivisionModel[]> {
    return this.get('/divisions', { company, region, name })
  }

  getAllRegion(company: string): Promise<any> {
    return this.get('/divisions/regions', { company })
  }

  createDivision(params: DivisionModel) {
    return this.post('/divisions', params)
  }

  updateDivision(params: DivisionModel) {
    return this.put(`/divisions/${params.id}`, params)
  }

  deleteDivision(id: string, company: string) {
    return this.delete(`/divisions/${id}/${company}`)
  }

  checkDivisionUsed(id: string, company: string) {
    return this.get(`/divisions/${id}/${company}/is-used`)
  }

  scanAllDivisions() {
    return this.get('/divisions/scanAll')
  }

  getAllUserDivisionAdmin() {
    return this.get('/users/division-admin')
  }

  getDivision(id: string, company: string) {
    return this.get(`/divisions/${id}/${company}`)
  }
}
